import React, { Fragment } from 'react';
import * as styles from './styles';

const PatientHeader = ({ patient }) => (
	<Fragment>
		<h3>Patient's details</h3>
		{patient && (
			<Fragment>
				<div>{`${patient.patientTitle} ${patient.patientName} ${patient.patientSurname}`}</div>
				<div>Medicare Number: {patient.patientMedicare}</div>
				<div>{`${patient.patientAddress || ''} ${patient.patientSuburb ||
					''} ${patient.patientPostcode || ''}`}</div>
			</Fragment>
		)}
		{patient.ihi && (
			<div className={styles.ihiSection}>
				<strong>IHI:</strong> {patient.ihi}
				<br />
				<strong>IHI Status:</strong> {patient.ihiStatus}
				<br />
				<strong>Record Status:</strong> {patient.recordStatus}
				<br />
			</div>
		)}
	</Fragment>
);

export default PatientHeader;



// WEBPACK FOOTER //
// ./src/components/Patient/index.js